// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { CaretakersRoutingModule } from './caretakers-routing.module';
// import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';

// Custom packages - Components
import { CaretakersListComponent } from 'src/app/modules/caretakers/pages/caretakers-list/caretakers-list.page';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    CaretakersRoutingModule,
    // PublicModule,
  ],
  declarations: [
    CaretakersListComponent,
  ],
  entryComponents: [
  ],
  exports: [
  ]
})
export class CaretakersModule { }
